"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Sortable = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var Sortable = _styledComponents["default"].ul.withConfig({
  displayName: "Sortablestyles__Sortable",
  componentId: "sc-1n5caqf-0"
})(function (_ref) {
  var hasZebraStripes = _ref.hasZebraStripes;
  return (0, _styledComponents.css)(["&,*{box-sizing:border-box;}margin:0;padding:0;", ""], hasZebraStripes && "\n      li:nth-of-type(even) {\n        background-color: ".concat(_tokens["default"].table.rowEven.backgroundColor, ";\n      }\n    "));
});

exports.Sortable = Sortable;
//# sourceMappingURL=Sortable.styles.js.map